import React from "react";

export const CallRibbon = (props) => {
    return (
        <div id='callribbon' className="call-container">
        <div className="calltext-section">
          <i className="fa fa-comments chat-icon"></i>
          <h1>
          {props.data
            ? props.data.ltext1
          : 'Loading...'} <br />
            <span>RO Service Solution</span>
          </h1>
        </div>
        {/*<img src="img/wedo/acImage.png" alt="AC Unit" className="callac-image" /> */}
        <div className="callcontact-section">
        <a href="tel:8920455953">
          <div className="call-icon-container">
            <i className="fa fa-phone call-icon"></i>
          </div>
          <p>Contact Us</p>
         
          <p className="phone-number" >+91 8920455953</p>
          </a>
        </div>
      </div>
    )
  }
  